<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{ `${this.$t("event.edit.title")}` }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("event.edit.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="6" xs="6" sm="6" md="3">
                  <v-img
                    v-if="![null, undefined, ''].includes(event.picture_url)"
                    :src="API_BASE_URL + '/uploads/' + event.picture_url"
                    width="150"
                    height="150"
                    contain
                    class="rounded-lg"
                  >
                  </v-img>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="event.title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                      serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="event.description"
                    name="description"
                    label="Description"
                    v-validate="'required'"
                    :error="
                      errors.first('description') != null ||
                      serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                      serverSideErrors.description
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-datetime-picker
                    label="Start Date"
                    clearable
                    dateFormat="dd-MM-yyyy"
                    timeFormat="HH:mm a"
                    name="start_datetime"
                    v-model="event.start_datetime"
                    v-validate="'required'"
                    :error="
                      errors.first('start_datetime') != null ||
                      serverSideErrors.start_datetime != null
                    "
                    :error-messages="
                      errors.first('start_datetime') ||
                      serverSideErrors.start_datetime
                    "
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock-outline</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-datetime-picker
                    label="End Date"
                    clearable
                    dateFormat="dd-MM-yyyy"
                    timeFormat="HH:mm a"
                    name="end_datetime"
                    v-validate="'required'"
                    v-model="event.end_datetime"
                    :error="
                      errors.first('end_datetime') != null ||
                      serverSideErrors.end_datetime != null
                    "
                    :error-messages="
                      errors.first('end_datetime') ||
                      serverSideErrors.end_datetime
                    "
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock-outline</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveEventDetail"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      user: {},
      loading: false,
      serverSideErrors: {},
      event: {
        title: "",
        description: "",
        start_datetime: new Date(),
        end_datetime: new Date(),
        picture_url: "",
      },
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    saveEventDetail() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          formData.append("title", this.event.title);
          formData.append("description", this.event.description);
          formData.append(
            "start_datetime",
            moment.utc(this.event.start_datetime).valueOf()
          );
          formData.append(
            "end_datetime",
            moment.utc(this.event.end_datetime).valueOf()
          );
          formData.append("picture", this.event.picture);

          _self.$axios
            .put("/societyadmin/events/" + _self.$route.params.id, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push({ path: "/societyadmin/event" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    getEventDetail() {
      let _self = this;
      _self.$axios
        .get("societyadmin/events/" + _self.$route.params.id)
        .then((response) => {
          let data = response.data;
          if (data.status) {
            data.event.start_datetime = new Date(data.event.start_datetime);
            data.event.end_datetime = new Date(data.event.end_datetime);
            _self.event = data.event;
          } else {
            if (data.errors) {
              _self.serverSideErrors = {};

              for (let i = 0; i < data.errors.length; i++) {
                _self.serverSideErrors[data.errors[i].field] =
                  data.errors[i].message;
              }
            } else {
              this.setAlert({
                showAlert: true,
                variant: "red accent-3",
                timeout: "2000",
                message: data.message,
              });
            }
          }
        });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getEventDetail();
  },
};
</script>
<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>